import { Injectable } from '@angular/core';
import { Address, PdqUser } from '@pdqdev/pdq-shared/dist/entities';

import { BehaviorSubject, Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ApiService } from '../../core/services/api/api.service';
import { UserService } from '@app/services/user/user.service';

export interface UpdateUserPayload {
  locations?: Address[];
  phoneNumber?: string;
  name?: string;
  title?: string;
  profilePictureUrl?: string;
}
@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private _users$ = new BehaviorSubject<PdqUser[]>([]);
  private _selectedUser$ = new BehaviorSubject<PdqUser>(null);
  constructor(
    private apiService: ApiService,
    private userService: UserService,
  ) {}

  get users$() {
    return this.userService.users$;
  }

  get selectedUser$() {
    return this._selectedUser$.asObservable();
  }

  /***********************************************************************
  Provides the last snapshot of selected user,
  prevents updating the wrong user-id if the user context switched too fast,
  for example the editor switched too fast to another user at side-panel
  ************************************************************************/
  get currentUser() {
    return this._selectedUser$.getValue();
  }
  set currentUser(user: PdqUser) {
    this._selectedUser$.next(user);
  }

  updateUser(userId: string, payload: UpdateUserPayload) {
    return new Observable((subscriber) => {
      this.apiService
        .put(`users-management/${userId}`, payload)
        .pipe(first())
        .subscribe(
          (updatedUser) => {
            this.updateUserState(updatedUser);
            subscriber.next(updatedUser);
          },
          (err) => {
            subscriber.error(err);
          },
        );
    });
  }
  private updateUserState(updatedUser: PdqUser) {
    const users = this._users$.getValue();
    const userIdx = users?.findIndex((user) => user.id === updatedUser.id);
    if (userIdx !== -1) {
      users[userIdx] = updatedUser;
      this._users$.next(users);
    }
  }
}
